<template>
  <div class="box">
    <form
      class="sign-up is-centered"
      @submit.prevent="onSubmit"
    >
      <img
        :src="logo"
        alt="logo"
      >

      <h1 class="title is-4 has-text-primary">
        Registro
      </h1>

      <SignUpWithRfcFields
        :loading="loading"
        :disabled="loading"
        refer-code
      />

      <ButtonSubmit
        :loading="loading"
        text="regístrate"
      />

      <LinkSignIn />
      <LinkForgottenPassword />
    </form>
  </div>
</template>

<script>
import merge from 'lodash/merge';
import {
  mapGetters,
  mapActions,
} from 'vuex';

export default {
  name: 'SignUpWithCompany',
  components: {
    LinkSignIn: () => import(/* webpackChunkName: "auth-link-sign-in" */ '@/components/Auth/LinkSignIn.vue'),
    LinkForgottenPassword: () => import(/* webpackChunkName: "auth-link-forgotten-password" */ '@/components/Auth/LinkForgottenPassword.vue'),
    ButtonSubmit: () => import(/* webpackChunkName: "auth-button-submit" */ '@/components/Auth/ButtonSubmit.vue'),
    SignUpWithRfcFields: () => import(/* webpackChunkName: "sign-up-with-rfc-fields" */ '@/components/Auth/SignUpWithRfcFields.vue'),
  },
  data() { return { loading: false }; },
  computed: merge(
    mapGetters({
      logo: 'ui/authLogo',
    }),
  ),
  async beforeMount() {
    try {
      await this.verifyCode();
    } catch ({ status, code, message }) {
      if (status === 409 && message === 'Confirmation code already exists') {
        this.$router.push({ name: 'SignIn' });
        this.$danger({ message: 'El usuario ya se encuentra registrado.' });
      }
    }
  },
  methods: merge(
    mapActions({
      signUpWithCompany: 'auth/signUpWithCompany',
      initAuthentication: 'auth/initAuthentication',
      verifyCode: 'auth/verifyConfirmationCode',
    }),
    {
      async onSubmit() {
        this.loading = true;

        try {
          await this.signUpWithCompany();

          this.$router.replace({ name: 'Dashboard' });
        } catch ({ message }) {
          this.$danger({ message });
        }

        this.loading = false;
      },
    },
  ),
};
</script>

<style scoped>
.box {
  padding: 3rem;
}

@media screen and (min-width: 769px) {
  form {
    max-width: 750px;
  }
}
</style>
